<template>
  <!-- <div v-if = "td.length > 0" id="layout">
    <FLoader />
    <HeaderPartial />
    <div class="main-content">
      <div class="container mt-3">
        <router-view />
        <MyDialog />
      </div>
    </div>
    <FooterPartial />
  </div> -->
  <div v-if="user">
    <!-- <div v-if="isShowNewDesign">
      <router-view />
    </div> -->
    <div class="relative">
      <div class="absolute top-0 left-0 w-full h-full" style="z-index: -9">
        <img src="../../assets/images/body-Bg.png" alt="Body Bg" class="w-full h-screen object-cover">
      </div>
      <FLoader />
      <headerNew v-if="isFromMobile != 1" />
      <div class="mobile:px-3 mobile:pt-28 laptop:pt-24 desktop:pt-16 largeDesktop:pt-20 largeDesktop:pl-10 pr-3 pb-4"
        :class="isFromMobile == 1 ? '!pt-[50px]' : ''">
        <GlobaldashboardHead />
        <!-- {{ isCollapsed }} -->
        <WelcomeCard :heading="'Welcome ' + (user ? user.user.full_name : '')"
          :text="'Let’s make today productive and achieve some great results'" />
        <div class="flex flex-grow items-start gap-5 ">
          <div class="flex items-start largeDesktop:gap-5 laptop:gap-4 mt-10 w-full transition duration-800" :class="{
            '!gap-0': $route.name === 'globalSearch' && isCollapsed
          }">
            <SidebarNavigation @sidebar-collapse="handleSidebarCollapse"
              class="!w-auto transition duration-800 flex-shrink-0 mobile:hidden laptop:flex" :class="{
                '!w-0': $route.name === 'globalSearch' && isCollapsed
              }" />
            <!-- <sidebar class="!w-auto transition duration-800 flex-shrink-0 mobile:hidden laptop:flex" /> -->

            <!-- Main Content -->
            <div class="flex-1 min-w-0 transition duration-1500" :class="{
              'w-[calc(100vw-320px)] mx-auto': !isCollapsed,  // 100vw - 64 (16rem = 256px)
              'mobile:w-auto mobile:flex-1 desktop:w-[calc(100vw-500px)] largeDesktop:w-[calc(100vw-700px)] mx-auto desktop:flex-none': $route.name === 'globalSearch' && isCollapsed,
            }">
              <!-- <dashboard /> -->
              <router-view></router-view>
            </div>
          </div>
        </div>
        <FooterPartial />
      </div>
      <!-- <div class="main-content">
          <div class="container mt-3">
            <router-view />
            <MyDialog />
          </div>
        </div> -->
    </div>
    <MyDialog />
    <ConfirmDialog />
  </div>
</template>

<script>
import headerNew from "../../components/layouts/header/header_new.vue";
import GlobaldashboardHead from "../globaldashboardHead.vue";
import SidebarNavigation from "../sidebarNavigation.vue";
import WelcomeCard from "../welcomeCard.vue";
import FooterPartial from "./footer/FooterPartial";
import sidebar from "../nest_components/omega_sidebar/sidebar.vue";
// import dashboard from "../../views/dashboard/dashboard.vue";

export default {
  name: "Layout",

  components: {
    headerNew,
    GlobaldashboardHead,
    WelcomeCard,
    SidebarNavigation,
    FooterPartial,
    // sidebar
    // dashboard
  },

  data() {
    return {
      td: '',
      user: JSON.parse(localStorage.getItem('user')) ?? null,
      isCollapsed: false // or true, depending on your default state
    };
  },

  computed: {
    isFromMobile() {
      return this.$route.query.is_from_mobile ?? 0;
    },

  },
  mounted() { },

  methods: {
    handleSidebarCollapse(isCollapsed) {
      this.isCollapsed = isCollapsed;
    }
  }
};
</script>
